<template>
  <v-form ref="form0" data-vv-scope="form0">
    <v-layout row>
     <v-radio-group  v-model="paydefault" @change="getValueRadio">
      <v-flex xs12 sm12 md12>
        <v-card>
         <v-list>
            <v-list-group v-for="item in items" :key="item.type" v-model="item.active" :prepend-icon="item.action" no-action>
              <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="$t(`message.${item.type}`)"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
              </template>
              <v-list-tile v-for="subItem in item.items"  :key="subItem.title"  @click="" >
                  <v-list-tile-avatar v-if="subItem.image">
                    <img  :src="subItem.image">
                  </v-list-tile-avatar>
                  <v-list-tile-avatar v-if="subItem.css">
                    <v-icon>{{ subItem.css }}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-avatar v-if="subItem.creditCard">
                     <v-icon>{{ subItem.creditCard.css }}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content v-if="subItem.creditCard">                    
                     <v-list-tile-title>{{ subItem.creditCard.paymentMethod}} **** {{subItem.creditCard.number}}</v-list-tile-title>
                     <v-list-tile-sub-title>Expiration: {{ subItem.creditCard.expirationDate}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                   <v-list-tile-content v-else>                    
                      <v-list-tile-title v-html="$t(`message.${subItem.type}`)"></v-list-tile-title>
                  </v-list-tile-content>
                   <v-list-tile-action>
                      <v-radio v-if="subItem.creditCard" name="paydefault" :jsonvalue="subItem" :value="subItem.creditCard.card_id"></v-radio>
                      <v-radio v-else name="paydefault" :jsonvalue="subItem" :value="subItem.type"></v-radio>

                    </v-list-tile-action>
               </v-list-tile>
            </v-list-group>
          </v-list>
        </v-card>
      </v-flex>
       </v-radio-group>
    </v-layout>
  </v-form>
</template>   


<script>
import { EventBus } from "./EventBus.js";
import axios from 'axios'
import cards from './../resources/cards'

export default {
  data() {
    return {
      paydefault:"card", 
      provider:'', 
      items: [],
      cards: cards,
      creditCard:null
    };
  },
  mounted() {
    this.$nextTick(function() {
        console.log("emite un next desde PaymetMehod");
        EventBus.$on('callerData_country', this.getPaymentMethod);
        EventBus.$on("next", this.validateForm0);
         EventBus.$on('resetForm0', this.reset);
        //this.getPaymentMethod();
    });
    console.log('mounted')
    this.paydefault = 'card';
  },
  updated(){

    console.log('updated',this.paydefault );
  },
  methods: {
    validateForm0(scope) {
      if (scope == "form0") {
        this.$emit("submit", {
          paydefault:this.paydefault,
          provider:this.provider,
          form: "form0"
        });
      }
    },
    getValueRadio(v){
      console.log(v);
      var h;
      var  payment;
      for(h = 0; h < this.items.length; h++){
        payment =   this.items[h].items.find(function(element){
            if(element.hasOwnProperty("creditCard") && element.creditCard.card_id === v){
               return element;
            }else if(element.type === v){
              return element;
            }
          });
        if(payment){
          break;
        }
        
      }
      console.log(payment.hasOwnProperty('expire') ? payment.expire : 'PT2H');
      this.creditCard = payment.hasOwnProperty('creditCard') ? payment.creditCard : null;
      EventBus.$emit('stepperView',{
        paymentMethod:v,
        item:payment,
        creditCard: payment.hasOwnProperty('creditCard') ? payment.creditCard : null,
        returnPaymentMethod:payment.hasOwnProperty('return') ? payment.return : '',
        expire:payment.hasOwnProperty('expire') ? payment.expire : ''
      });
    },
    getPaymentMethod(data){
      var country = data.buyer.country;
      var h;
      console.log("getPaymentMethod >>>>>>>>>>>");
      
          axios.post(process.env.VUE_APP_GETMETHOD, {
                  country_name: country,
                  wallet_id: data.wallet_id,
                  buyerId: data.buyer.email,
                  environment: data.environment,
                  mode:data.mode
              } , {
                  headers: { 'Content-Type': 'application/json', }
              }
          )
          .then(response => {
             if(response.data.length > 0){
                var cardcss; 
                this.items = response.data[0].paymentMethod;
                this.provider = response.data[0].provider;
                var cardpay = this.items.find(el => el.type === 'creditcard');
                if(cardpay.items.length == 1){
                     this.paydefault = 'card';
                }else{
                    for (h = 0; h < cardpay.items.length; h++) {
                          if(cardpay.items[h].hasOwnProperty('creditCard')){
                              cardcss = this.cards.find(el => el.type === cardpay.items[h].creditCard.paymentMethod);
                              cardpay.items[h].creditCard.css = cardcss.css;
                              if(cardpay.items[h].creditCard.default){
                                  this.paydefault = cardpay.items[h].creditCard.card_id;
                              }
                          }  
                    }
                }
                this.getValueRadio(this.paydefault);

                //var defaultcard = cardpay.items.find(el => el.creditCard.default);
               // this.paydefault = defaultcard.creditCard.card_id;
             } 
          })
          .catch(error => {
            console.log(error);
              console.log('not supported country');
          });
    },
    reset() {
            console.log("reset >>>>>>>>>>>>>");
            if (this.$refs.form0 !== undefined) {
                console.log('Payment Info defined');
                //this.$refs.form0.reset();
                 this.paydefault = 'card';
                 this.getValueRadio(this.paydefault);
            } else {
                console.log('Payment Info not defined');
            }

        },

  }
};
</script>
   
<style>
 .v-input--selection-controls .v-input__control {
        width: 100%;
    }
</style>
